import { PartnerName } from '@ctct/domain-layer';
import { distUI } from '@ctct/infrastructure-layer';
import type { PaymentButtonPageStore } from '@ctct/state-client-layer';

import { createActiveConsentTermsStrategy, createDefaultTermsStrategy } from './TermsStrategy';

export class TermsAndConditionsService {
  constructor(private pageStore: PaymentButtonPageStore, private partnerName: string | undefined) {}

  public api() {
    return {};
  }

  public handlers() {
    return {
      setHasAcceptedTermsAndConditions: (hasAccepted: boolean) => this.setHasAcceptedTermsAndConditions(hasAccepted),
    };
  }

  public data() {
    return {
      requiresActiveTermsConsent: ({ isPadPayment }: { isPadPayment: boolean }) =>
        this.getTermsStrategy(isPadPayment).requiresActiveTermsConsent(),
    };
  }

  private setHasAcceptedTermsAndConditions(hasAccepted: boolean) {
    this.pageStore.setState({
      paymentButtonHasAcceptedTerms: hasAccepted,
      ...(hasAccepted ? { paymentButtonTermsErrorMessage: null } : null),
    });
    distUI.track({ action: 'order-summary-terms-and-conditions-toggled' }, { currentValue: hasAccepted });
  }

  public getTermsStrategy = (isPadPayment: boolean) => {
    if (isPadPayment) {
      return createActiveConsentTermsStrategy();
    }

    if (!this.partnerName) {
      return createDefaultTermsStrategy();
    }

    return new PartnerName(this.partnerName).requiresActiveTermsAndConditionsConsent()
      ? createActiveConsentTermsStrategy()
      : createDefaultTermsStrategy();
  };
}
